import * as net from 'util/Net';

export interface CreateAntibodyFormatInput {
  veritasName: string;
  displayName?: string;
}

export function createAntibodyFormat(input: CreateAntibodyFormatInput): Promise<{antibodyFormatId: string}> {
  return net.postJSONPromise({
    url: '/1/api/antibody-formats',
    data: input,
  });
}
